import {Tooltip} from "./Tooltip";
import {RoundButtonStyled} from "./RoundButton.styled";
import {SvgIcon} from "./SvgIcon";

export function RoundButton({ icon, title, onClick }) {
    return (
        <Tooltip text={title}>
            <RoundButtonStyled onClick={onClick}>
                <SvgIcon href={icon} size={24}></SvgIcon>
            </RoundButtonStyled>
        </Tooltip>
    );
}
